import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KnowledgeDomainType } from "../../../types/KnowledgeDomain";

const initialState: KnowledgeDomainType = {
    description: "",
    code: "",
    status: true,
    id: ""
};

export const knowledgeDomainSlice = createSlice({
    name: "knowledgeDomainForm",
    initialState,
    reducers: {
        setKnowledgeDomainData: (state, action: PayloadAction<KnowledgeDomainType>) => {
            return { ...state, ...action.payload };
        },
        resetKnowledgeDomainData: () => {
            return initialState;
        }
    }
});

export const { setKnowledgeDomainData, resetKnowledgeDomainData } = knowledgeDomainSlice.actions;
export default knowledgeDomainSlice.reducer;
